export default {
    'Oh no...': {
        ru: 'Ой...',
        es: 'Oh no...',
        pt: 'Oh não...',
        fr: 'Oh non...',
        de: 'Oh nein...',
        it: 'Oh no...',
        nl: 'Oh nee...',
        pl: 'O nie...',
        id: 'Oh tidak...',
        tr: 'Olamaz...',
        ko: '이런...',
        no: 'Å nei...',
        sv: 'Åh, nej...',
        jp: 'そんな...',
        fi: 'Voi ei...',
        lv: 'Ak nē...',
        da: 'Åh nej...',
        uk: 'О, ні...',
        ro: 'Oh, nu...',
    },
    "The project is temporarily disabled because the owner hasn't renewed the subscription.": {
        ru: 'Автор этого проекта не продлил подписку, и проект временно отключен.',
        es: 'El proyecto está temporalmente desactivado porque el propietario no ha renovado la suscripción.',
        pt: 'O projeto está temporariamente desativado porque o proprietário não renovou a subscrição.',
        fr: "Le projet est temporairement désactivé car le propriétaire n'a pas renouvelé son abonnement.",
        de: 'Das Projekt ist vorübergehend deaktiviert, weil der Eigentümer das Abonnement nicht verlängert hat.',
        it: "Il progetto è temporaneamente disattivato perché il proprietario non ha rinnovato l'abbonamento.",
        nl: 'Het project is tijdelijk uitgeschakeld omdat de eigenaar het abonnement niet heeft vernieuwd.',
        pl: 'Projekt jest tymczasowo wyłączony, ponieważ właściciel nie odnowił subskrypcji.',
        id: 'Proyek ini dinonaktifkan sementara karena pemiliknya belum memperbarui langganan.',
        tr: 'Proje, sahibi aboneliğini yenilemediği için geçici olarak devre dışı bırakıldı.',
        ko: '소유자가 구독을 갱신하지 않아서 프로젝트가 일시적으로 비활성화되었습니다.',
        no: 'Prosjektet er midlertidig deaktivert fordi eieren ikke har fornyet abonnementet.',
        sv: 'Projektet är tillfälligt inaktiverat eftersom ägaren inte har förnyat prenumerationen.',
        jp: 'オーナーがサブスクリプションを更新していないため、プロジェクトは一時的に無効になっています。',
        fi: 'Projekti on tilapäisesti poistettu käytöstä, koska omistaja ei ole uusinut tilausta.',
        lv: 'Projekts uz laiku ir atspējots, jo īpašnieks nav atjaunojis abonementu.',
        da: 'Projektet er midlertidigt deaktiveret, fordi ejeren ikke har fornyet sit abonnement.',
        uk: 'Проєкт тимчасово не працює, оскільки власник не продовжив підписку.',
        ro: 'Proiectul este temporar dezactivat deoarece proprietarul nu a reînnoit abonamentul.',
    },
    'Oops...': {
        es: 'Uy...',
        pt: 'Ops...',
        fr: 'Oups...',
        ru: 'Ой...',
        de: 'Hoppla...',
        it: 'Ops...',
        pl: 'Ups...',
        uk: 'Упс...',
        lv: 'Ak...',
        nl: 'Oeps...',
        id: 'Ups...',
        no: 'Ups...',
        da: 'Ups...',
        sv: 'Oj...',
        fi: 'Hups...',
        ro: 'Oops...',
        tr: 'Oops...',
        ko: '죄송합니다...',
        jp: 'おっと...。',
    },
    'This project has exceeded the allowed view limit. Please try again later.': {
        es: 'Este proyecto ha superado el límite de visitas permitido. Vuelva a intentarlo más tarde.',
        pt: 'Este projeto excedeu o limite de visualizações permitido. Tente novamente mais tarde.',
        fr: "Ce projet a dépassé la limite d'affichage autorisée. Veuillez réessayer plus tard.",
        ru: 'Проект превысил разрешенное количество просмотров. Попробуйте зайти позже.',
        de:
            'Dieses Projekt hat die zulässige Anzahl der Ansichten überschritten. Bitte versuchen Sie es später noch einmal.',
        it: 'Questo progetto ha superato il limite di visualizzazione consentito. Riprovare più tardi.',
        pl: 'Ten projekt przekroczył dozwolony limit wyświetleń. Spróbuj ponownie później.',
        uk: 'Цей проект перевищив допустимий ліміт перегляду. Будь ласка, спробуйте пізніше.',
        lv: 'Šis projekts ir pārsniedzis atļauto skatījumu limitu. Lūdzu, mēģiniet vēlreiz vēlāk.',
        nl: 'Dit project heeft de toegestane weergavelimiet overschreden. Probeer het later nog eens.',
        id: 'Proyek ini telah melampaui batas tampilan yang diizinkan. Silakan coba lagi nanti.',
        no: 'Dette prosjektet har overskredet den tillatte visningsgrensen. Vennligst prøv igjen senere.',
        da: 'Dette projekt har overskredet den tilladte visningsgrænse. Prøv venligst igen senere.',
        sv: 'Detta projekt har överskridit den tillåtna visningsgränsen. Vänligen försök igen senare.',
        fi: 'Tämä projekti on ylittänyt sallitun katselurajan. Yritä myöhemmin uudelleen.',
        ro: 'Acest proiect a depășit limita de vizualizare permisă. Vă rugăm să încercați din nou mai târziu.',
        tr: 'Bu proje izin verilen görüntüleme sınırını aştı. Lütfen daha sonra tekrar deneyin.',
        ko: '이 프로젝트는 허용된 보기 제한을 초과했습니다. 나중에 다시 시도하세요.',
        jp: 'このプロジェクトは閲覧制限を超えています。後でもう一度お試しください。',
    },
}
